import { useRouter } from "next/router";
import Image from "../global/Image";
import { v4 as uuidv4 } from "uuid";
import CurrencyIcon from "../icons/CurrencyIcon";

const FreeGifts = ({ productFees }) => {
  const { locale } = useRouter();
  if (productFees?.length == 0) return null;

  return (
    <section className="max-sm:mb-4">
      {/* <h1 className="w-11/12 mx-auto mb-2 sm:mb-4">
        <span className="text-[#744A91] text-base sm:text-[25px] font-bold">
          Free gifts with 100.00 SR
        </span>
        <span className="text-[#919392] max-sm:text-sm">
          {" "}
          ( The product will be added to the cart automatically. ){" "}
        </span>
      </h1> */}
      <div className="ms-[4.5%] flex items-center overflow-x-auto gap-4">
        {Object.values(productFees?.at(0)?.options || [])?.map((fee) => (
          <div
            key={uuidv4()}
            className="flex items-center gap-5 p-3 border rounded-md min-w-72 sm:min-w-96 max-w-72 sm:max-w-96"
          >
            <Image
              src="/imgs/pdp-free-gift.png"
              className="size-14 sm:size-[90px] object-contain"
              loading="lazy"
              alt="Free Gift Img!"
            />
            <div className="flex flex-col">
              <p className="text-sm font-bold sm:text-lg">
                {locale == "en" ? fee?.title : fee?.title_ar}
              </p>
              <p className="text-[#744A91] flex items-center gap-1 font-bold">
                {Number(fee?.price)} <CurrencyIcon className="size-3.5" />
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FreeGifts;
